import { Component } from '@angular/core';

@Component({
  selector: 'app-left-website',
  templateUrl: './left-website.component.html',
  styleUrls: ['./left-website.component.scss'],
})
export class LeftWebsiteComponent {}
